const Reflux = require('@muzzylane/reflux');
const _ = {
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
};

const Globals = require('../../../app/globals');
const ShortCourseInstanceActions = require('../actions/ShortCourseInstanceActions');

let shortCourseInstances = {};
let shortCourseInstancesMin = {}; // minimal information for short courses from not-logged-in requests
let minShortCourseInstances = {}; // batch fetch for short courses to display in list format
let shortCourseInstancePreviewData = {}; // parameters needed to preview a short course given instanceHash
let localShortCourseAuths = {};
let intializedLocalMin = false;
let playUrls = {};
let playViewState = {};
let userSummaries = [];
let action = {};
let loggedOutOf3pUser = false;

const ShortCourseInstanceStore = Reflux.createStore({
    listenables: [ShortCourseInstanceActions],
    init: function() {},

    resetState: function() {
        minShortCourseInstances = {};
        shortCourseInstances = {};
        shortCourseInstancesMin = {};
        shortCourseInstancePreviewData = {};
        localShortCourseAuths = {};
        playUrls = {};
        loggedOutOf3pUser = false;
        intializedLocalMin = false;
        playViewState = {};
        userSummaries = [];
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            loggedOutOf3pUser: loggedOutOf3pUser,
            minShortCourseInstances: minShortCourseInstances,
            intializedLocalMin: intializedLocalMin,
            shortCourseInstances: shortCourseInstances,
            shortCourseInstancesMin: shortCourseInstancesMin,
            shortCourseInstancePreviewData: shortCourseInstancePreviewData,
            localShortCourseAuths: localShortCourseAuths,
            playUrls: playUrls,
            playViewState,
            userSummaries,
            action: action,
        };
    },
    
    getUserSummary: function(user_id) {
        const integration_type = Globals.integration_type.LOCAL;
        return _.find(userSummaries,{user_id,integration_type});
    },
    
    getIsTransitioning: function() {
        if (playViewState.active) {
            // console.log(">>>-----> PLAY VIEW ACTIVE (TRANSITIONING)");
            return true;
        }
        
        // we know the play view component is gone, but we may have gotten new data while the play view was being created  
        // or it may have happened while the view component was shutting down.
        
        if (!playViewState.lastGetTime) {
            // we haven't got new data since the playViewState became active
            // console.log(">>>-----> TRANSITIONING");
            return false; 
        }
        
        let on_delta = Math.abs(playViewState.lastGetTime - playViewState.lastOnTime);
        let off_delta = Math.abs(playViewState.lastGetTime - playViewState.lastOffTime);
        if (on_delta < off_delta) {
            // we got new data closer to the time the component became active than when it was shut down
            // console.log(">>>-----> STILL TRANSITIONING");
            return true; 
        }
        
        return false;
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    getStateShortCourseInstance: function(instanceHash) {
        return {
            loggedOutOf3pUser: loggedOutOf3pUser,
            minShortCourseInstance: minShortCourseInstances[instanceHash],
            intializedLocalMin: intializedLocalMin,
            shortCourseInstance: shortCourseInstances[instanceHash],
            shortCourseInstanceMin: shortCourseInstancesMin[instanceHash],
            shortCourseInstancePreviewData: shortCourseInstancePreviewData[instanceHash],
            localShortCourseAuths: localShortCourseAuths[instanceHash],
            playUrls: playUrls[instanceHash] || {},
            action: action,
        };
    },

    onCreateLocalShortCourseInstanceCompleted: function(actionId, res) {
        // console.log('onCreateLocalShortCourseInstanceCompleted', actionId, res);
        action = { id: actionId, newInstanceHash: res.hash };
        shortCourseInstances[res.hash] = res;
        this.emitStatus();
    },

    onCreateLocalShortCourseInstanceFailed: function(actionId, err) {
        console.warn('onCreateLocalShortCourseInstanceFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onArchiveLocalShortCourseInstanceCompleted: function(actionId, courseInstanceHash, res) {
        // console.log('onArchiveLocalShortCourseInstanceCompleted', actionId, courseInstanceHash, res);
        action = { id: actionId };
        if (minShortCourseInstances[courseInstanceHash]) delete minShortCourseInstances[courseInstanceHash];
        if (shortCourseInstances[courseInstanceHash]) delete shortCourseInstances[courseInstanceHash];
        this.emitStatus();
    },

    onArchiveLocalShortCourseInstanceFailed: function(actionId, courseInstanceHash, err) {
        console.warn('onArchiveLocalShortCourseInstanceFailed', actionId, courseInstanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetShortCourseInstanceCompleted: function(actionId, courseInstanceHash, data) {
        // console.log('onGetShortCourseInstanceCompleted', actionId, data);
        action = { id: actionId };
        shortCourseInstances[courseInstanceHash] = data;
        playViewState.lastGetTime = Date.now();
        playViewState.lastGetHash = courseInstanceHash;
        this.emitStatus();
    },

    onGetShortCourseInstanceFailed: function(actionId, courseInstanceHash, err) {
        console.warn('onGetShortCourseInstanceFailed', actionId, courseInstanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetShortCourseInstanceMinimalCompleted: function(actionId, courseInstanceHash, data) {
        // console.log('onGetShortCourseInstanceMinimalCompleted', actionId, courseInstanceHash, data);
        action = { id: actionId };
        shortCourseInstancesMin[courseInstanceHash] = data;
        this.emitStatus();
    },

    onGetShortCourseInstanceMinimalFailed: function(actionId, courseInstanceHash, err) {
        console.warn('onGetShortCourseInstanceMinimalFailed', actionId, courseInstanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetShortCourseInstancePreviewDataCompleted: function(actionId, courseInstanceHash, data) {
        // console.log('onGetShortCourseInstancePreviewDataCompleted', actionId, courseInstanceHash, data);
        action = { id: actionId };
        shortCourseInstancePreviewData[courseInstanceHash] = data;
        this.emitStatus();
    },

    onGetShortCourseInstancePreviewDataFailed: function(actionId, courseInstanceHash, err) {
        console.warn('onGetShortCourseInstancePreviewDataFailed', actionId, courseInstanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },


    onGetMinimalCourseInstancesForUserCompleted: function(actionId, _minShortCourseInstances) {
        action = { id: actionId };
        intializedLocalMin = true;
        _minShortCourseInstances.map((_minCourseInstance) => {
            minShortCourseInstances[_minCourseInstance.hash] = _minCourseInstance;
        });
        this.emitStatus();
    },

    onGetMinimalCourseInstancesForUserFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onGetCourseInstanceSummariesForUserCompleted: function(actionId, _data) {
        action = { id: actionId };
        
        let { user_id, integration_type } = _data;
        if (!user_id || !integration_type) {
            console.warn("onGetCourseInstanceSummariesForUserCompleted did not have user_id and/or integration_type",_data);
        }
        else {
            let query = { user_id, integration_type };
            let index = _.findIndex(userSummaries,query);
            if (index < 0) {
                userSummaries.push({..._data});
            }
            else {
                userSummaries[index] = {..._data };
            }
        }
        this.emitStatus();
    },

    onGetCourseInstanceSummariesForUserFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAuthorizeLocalCourseInstanceUserCompleted: function(actionId, instanceHash, res) {
        // console.log('onAuthorizeLocalCourseInstanceUserCompleted', actionId, instanceHash, res)
        action = { id: actionId };
        localShortCourseAuths[instanceHash] = res;
        this.emitStatus();
    },

    onAuthorizeLocalCourseInstanceUserFailed: function(actionId, instanceHash, err) {
        console.warn('onAuthorizeLocalCourseInstanceUserFailed', actionId, instanceHash, err)
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAuthorizeLocalCourseInstanceAccessCodeCompleted: function(actionId, instanceHash, res) {
        // console.log('onAuthorizeLocalCourseInstanceAccessCodeCompleted', actionId, instanceHash, res)
        action = { id: actionId };
        localShortCourseAuths[instanceHash] = res;
        this.emitStatus();
    },

    onAuthorizeLocalCourseInstanceAccessCodeFailed: function(actionId, instanceHash, err) {
        console.warn('onAuthorizeLocalCourseInstanceAccessCodeUserFailed', actionId, instanceHash, err)
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onPlayShortCourseInstanceContentBlockCompleted: function(actionId, instanceHash, contentBlockHash, playObj) {
        // console.log('onGetShortCourseInstanceCompleted', actionId, instanceHash, contentBlockHash, playObj);
        action = { id: actionId };
        if (!playUrls[instanceHash]) playUrls[instanceHash] = {};

        playUrls[instanceHash][contentBlockHash] = {
            allowPlay: playObj.allowPlay,
            playUrl: playObj.playUrl,
            enableStudentFeedback: playObj.enableStudentFeedback,
        }
        this.emitStatus();
    },

    onPlayShortCourseInstanceContentBlockFailed: function(actionId, err) {
        console.warn('onPlayShortCourseInstanceContentBlockFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onSetShortCourseInstanceAvatarCompleted: function(actionId, params, data) {
        // console.log('onSetShortCourseInstanceAvatarCompleted', params, data);
        action = { id: actionId };
        const courseInstanceHash = params.instanceHash;
        if (shortCourseInstances[courseInstanceHash] && 
            shortCourseInstances[courseInstanceHash].user && 
            shortCourseInstances[courseInstanceHash].user.id === data.user_id) {
            shortCourseInstances[courseInstanceHash].user.avatar = data.avatar;
        }
        this.emitStatus();
    },

    onSetShortCourseInstanceAvatarFailed: function(actionId, params, err) {
        console.warn('onSetShortCourseInstanceAvatarFailed', actionId, params, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onSetShortCourseInstanceClientStateCompleted: function(actionId, params, data) {
        // console.log('onSetShortCourseInstanceClientStateCompleted', params, data);
        action = { id: actionId };
        const courseInstanceHash = params.instanceHash;
        if (shortCourseInstances[courseInstanceHash] && 
            shortCourseInstances[courseInstanceHash].user && 
            shortCourseInstances[courseInstanceHash].user.id === data.user_id) {
            shortCourseInstances[courseInstanceHash].user.client_state = data.client_state;
        }
        this.emitStatus();
    },

    onSetShortCourseInstanceClientStateFailed: function(actionId, params, err) {
        console.warn('onSetShortCourseInstanceClientStateFailed', actionId, params, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    
    onSetPlayViewActiveCompleted: function(actionId, instanceHash, active) {
        // console.log(`onSetPlayViewActiveCompleted instanceHash=${instanceHash} active=${active})`);
        action = { id: actionId };
        playViewState = {
            active, 
            instanceHash,
        };
        if (active) {
            playViewState.lastOnTime = Date.now();
            playViewState.lastGetTime = null;
        }
        else {
            playViewState.lastOffTime = Date.now();
        }
        this.emitStatus();
    },
    
    onResetShortCourseInstanceAttemptsCompleted: function(actionId, instanceHash, resetObj) {
        // console.log('onResetShortCourseInstanceAttemptsCompleted', instanceHash, resetObj);
        action = { id: actionId };
        this.emitStatus();
    },

    
    onResetShortCourseInstanceAttemptsFailed: function(actionId, err) {
        console.warn('onResetShortCourseInstanceAttemptsCompleted', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddUsersToShortCourseInstanceCompleted: function(actionId, courseInstanceHash, data) {
        // console.log('onAddUsersToShortCourseInstanceCompleted', actionId, courseInstanceHash, data);
        action = { id: actionId };
        shortCourseInstances[courseInstanceHash] = data;
        // playViewState.lastGetTime = Date.now();
        // playViewState.lastGetHash = courseInstanceHash;
        this.emitStatus();
    },

    onAddUsersToShortCourseInstanceFailed: function(actionId, courseInstanceHash, err) {
        console.warn('onAddUsersToShortCourseInstanceFailed', actionId, courseInstanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onSetShortCourseInstanceDescInternalCompleted: function(actionId, instanceHash, parsedDesc) {
        // console.log('onSetShortCourseInstanceDescInternalCompleted', actionId, instanceHash, parsedDesc);
        action = { id: actionId };
        if (!shortCourseInstances[instanceHash]) shortCourseInstances[instanceHash] = {};
        
        shortCourseInstances[instanceHash].description_internal = parsedDesc;
        this.emitStatus();
    },

    onSetShortCourseInstanceDescInternalFailed: function(actionId, instanceHash, err) {
        console.warn('onSetShortCourseInstanceDescInternalFailed', actionId, instanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onCompleteChatbotActivityCompleted: function(actionId, params, result) {
        action = { id: actionId };
        let instanceData = shortCourseInstances[params.instanceHash];
        console.log("onCompleteChatbotActivityCompleted",instanceData,result); // FIXME: TODO - update data with results
        this.emitStatus();
    },
    onCompleteChatbotActivityFailed: function(actionId, params, err) {
        console.warn('onCompleteChatbotActivityFailed', actionId, params, err);
    },

    onAddShortCourseInstanceAdminCompleted: function(actionId, instanceHash, res) {
        // console.log('onAddShortCourseInstanceAdminCompleted:', actionId, instanceHash, res);
        action = { id: actionId };
        this.emitStatus();
    },

    onAddShortCourseInstanceAdminFailed: function(actionId, instanceHash, err) {
        console.warn('onAddShortCourseInstanceAdminFailed:', actionId, instanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

module.exports = ShortCourseInstanceStore;